import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import TreeNode from "./treeView";
import Preloading from "../../../components/basics/Preloading";
import methods from "../../../services/utility";
import back from "../../../assets/images/icons/arrow-right2.svg";
import apiMethod from "../../../services/api-service";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

const CreateCategoryWarhouse = () => {
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showWareHouseFormModal, setShowWareHouseFormModal] = useState(false);
  const [wareHouseType, setWareHouseType] = useState([]);
  const [categoryWareHouse, setCategoryWareHouse] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteNode, setSelectedDeleteNode] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [warehouseForm, setWarehouseForm] = useState({
    id: 0,
    title: "",
    description: "",
    code: "",
    warehouseType: "",
    categoryId: null,
    branchId: null,
    parentId: null,
    restaurantId: Number(restaurantId),
  });

  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    code: "",
    description: "",
    parentId: null,
    restaurantId: restaurantId,
    branchId: null,
  });

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getWarHouseType();
      await getUserBranches();
      setLoading(false);
    };
    bindData();
  }, []);

  useEffect(() => {
    loadRootCategories();
  }, []);

  const loadRootCategories = async () => {
    setLoading(true);

    const resp = await apiMethod.getWarehouseCategoriesTree(
      null,
      null,
      restaurantId,
      null,
      null,
      null
    );

    if (methods.showApiErrors(resp)) {
      const mapped = resp.data.map(mapApiNode);
      setTreeData(mapped);
      setCategoryWareHouse(resp.data);
    }

    setLoading(false);
  };

  const mapApiNode = (item) => ({
    id: item.id,
    label: item.title,
    title: item.title,
    description: item.description,
    code: item.code,
    parentId: item.parentId,
    branchId: item.branchId,

    childCount: item.childCount,
    warehouseCount: item.warehouseCount,

    nodeType: "category",
    children: item.childCount > 0 || item.warehouseCount > 0 ? null : [],
  });

  const loadChildren = async (node) => {
    const resp = await apiMethod.getWarehouseCategoriesTree(
      null,
      node.id,
      restaurantId,
      null,
      null,
      null
    );

    if (!methods.showApiErrors(resp)) return [];

    return resp.data.map(mapApiNode);
  };

  const loadWarehouses = async (categoryNode) => {
    const resp = await apiMethod.getWarehousesByCategory(
      categoryNode.id,
      restaurantId
    );

    if (!methods.showApiErrors(resp)) return [];

    return resp.data.map(mapWarehouseNode);
  };

  const handleLoadChildren = async (node) => {
    if (node.children !== null) return;

    let children = [];

    // 1️⃣ Load category children
    if (node.childCount > 0) {
      children = await loadChildren(node);
    }

    // 2️⃣ Load warehouses
    if (node.warehouseCount > 0) {
      const warehouses = await loadWarehouses(node);
      children = [...children, ...warehouses];
    }

    const updateTree = (nodes) =>
      nodes.map((n) =>
        n.id === node.id
          ? { ...n, children }
          : n.children
          ? { ...n, children: updateTree(n.children) }
          : n
      );

    setTreeData((prev) => updateTree(prev));
  };

  const getWarHouseType = async () => {
    const resp = await apiMethod.getWarehouseTypes();
    if (methods.showApiErrors(resp)) {
      setWareHouseType(resp.data);
    }
  };

  const getUserBranches = async () => {
    const resp = await apiMethod.getUserBranches();
    if (methods.showApiErrors(resp)) {
      setBranchList(resp.data);
    }
  };
  // const getCategory = async () => {
  //   const resp = await apiMethod.getWarehouseCategoriesTree(
  //     filterModel.branchId,
  //     filterModel.parentId,
  //     filterModel.restaurantId,
  //     filterModel.title,
  //     filterModel.size,
  //     filterModel.part
  //   );
  //   if (methods.showApiErrors(resp)) {
  //     setCategoryWareHouse(resp.data);
  //   }
  // };
  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.description = "";
    setFormModel({ ...formModel });
  };

  const closeWarehouseModal = () => {
    // resetForm();
    setWarehouseForm({
      id: 0,
      title: "",
      description: "",
      code: "",
      warehouseType: "",
      categoryId: null,
      parentId: null,
      branchId: "",
      restaurantId: Number(restaurantId),
    });
    setShowWareHouseFormModal(false);
  };

  const openWareHouseModal = (node) => {
    if (node.nodeType === "warehouse") {
      // 🟨 EDIT warehouse
      setWarehouseForm({
        id: node.id,
        title: node.title,
        description: node.description,
        code: node.code,
        warehouseType: node.warehouseType,
        categoryId: node.categoryId,
        branchId: Number(node.branchId),
        parentId: node.parentId ?? null,
        restaurantId: Number(restaurantId),
      });
    } else {
      // 🟦 ADD new warehouse under category
      setWarehouseForm({
        id: 0,
        title: "",
        description: "",
        code: "",
        warehouseType: "",
        categoryId: node.id,
        parentId: null,
        branchId: "",
        restaurantId: Number(restaurantId),
      });
    }

    setShowWareHouseFormModal(true);
  };

  const saveWarehouse = async () => {
    if (!warehouseForm.title || !warehouseForm.categoryId) return;

    setLoading(true);
    const payload = {
      ...warehouseForm,
      branchId: Number(warehouseForm.branchId),
      warehouseType: Number(warehouseForm.warehouseType),
      categoryId: Number(warehouseForm.categoryId),
      restaurantId: Number(warehouseForm.restaurantId),
    };

    const resp = await apiMethod.createWarehouse(payload);

    setLoading(false);

    if (!methods.showApiErrors(resp)) return;

    // close modal
    setShowWareHouseFormModal(false);

    // // reset form
    setWarehouseForm({
      id: 0,
      title: "",
      description: "",
      code: "",
      warehouseType: "",
      categoryId: null,
      parentId: null,
      branchIdL: "",
      restaurantId: Number(restaurantId),
    });

    loadRootCategories(); // refresh tree & warehouseCount
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const openModalCategory = () => {
    resetForm();
    setShowFormModal(true);
  };

  const saveCategory = async () => {
    if (!formModel.title) return;

    setLoading(true);

    const resp = await apiMethod.createWarehouseCategory(formModel);

    setLoading(false);

    if (!methods.showApiErrors(resp)) return;

    setFormModel((prev) => ({
      ...prev,
      title: "",
      description: "",
      id: 0,
      parentId: null,
    }));

    closeModal();
    loadRootCategories();
  };

  const handleAddCategory = (node) => {
    setFormModel({
      id: 0,
      title: "",
      description: "",
      code: "",
      parentId: node.id,
      restaurantId,
      branchId: null,
    });

    setShowFormModal(true);
  };

  const handleEditCategory = (node) => {
    setFormModel({
      id: node.id,
      title: node.label,
      description: node.description ?? "",
      code: node.code ?? "",
      parentId: node.parentId ?? null,
      restaurantId,
      branchId: node.branchId ?? null,
    });

    setShowFormModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedDeleteNode(null);
  };

  const deleteNode = async () => {
    if (!selectedDeleteNode) return;

    setLoading(true);

    let resp;
    if (selectedDeleteNode.nodeType === "warehouse") {
      // DELETE warehouse
      resp = await apiMethod.removeWarehouse(selectedDeleteNode.id);
    } else {
      // DELETE category
      resp = await apiMethod.removeWarehouseCategory(selectedDeleteNode.id);
    }

    setLoading(false);

    if (!methods.showApiErrors(resp)) return;

    setShowDeleteModal(false);
    setSelectedDeleteNode(null);

    loadRootCategories(); // refresh tree
  };

  const mapWarehouseNode = (w) => ({
    id: w.id,
    label: w.title,
    title: w.title,
    code: w.code,
    description: w.description,
    warehouseType: w.warehouseType,
    branchId: w.branchId,
    categoryId: w.categoryId,
    parentId: w.parentId,
    restaurantId: w.restaurantId,

    // tree specific
    nodeType: "warehouse",
    childCount: 0,
    warehouseCount: 0,
    children: [],
  });

  const categoryModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">افزودن / ویرایش دسته بندی جدید</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="col-12 mb-4">
              <label className="form-label required-label">عنوان</label>
              <input
                className="form-control input-form"
                type="text"
                style={{ direction: "rtl", textAlign: "right" }}
                value={formModel.title}
                onChange={(e) =>
                  setFormModel({ ...formModel, title: e.target.value })
                }
                placeholder="عنوان را بنویسید"
              />
            </div>
            <div className="col-12">
              <label className="form-label">توضیحات</label>
              <textarea
                className="form-control input-textarea"
                rows={4}
                style={{ direction: "rtl", textAlign: "right" }}
                value={formModel.description}
                onChange={(e) =>
                  setFormModel({ ...formModel, description: e.target.value })
                }
                placeholder="توضیحات را بنویسید"
              ></textarea>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeModal}
              >
                انصراف
              </button>
              <button
                type="button"
                className="btn custome-btn btn-purple"
                onClick={saveCategory}
              >
                ثبت و ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const addWarehouseModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showWareHouseFormModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">افزودن / ویرایش انبار جدید</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeWarehouseModal}
              ></button>
            </div>
            <div className="row g-2 mt-5">
              <div className="col-md-4 mb-3">
                <label htmlFor="categoryWarHouse" className="form-label">
                  نوع انبار
                </label>
                <select
                  id="categoryWarHouse"
                  className="form-select input-select"
                  aria-label="Default select example"
                  value={warehouseForm.warehouseType}
                  onChange={(e) =>
                    setWarehouseForm({
                      ...warehouseForm,
                      warehouseType: e.target.value,
                    })
                  }
                >
                  <option value="">انتخاب کنید</option>
                  {wareHouseType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="col-md-4 mb-3">
                <label htmlFor="categoryWarHouse" className="form-label">
                  دسته بندی انبار
                </label>
                <select
                  id="categoryWarHouse"
                  className="form-select input-select"
                  aria-label="Default select example"
                  value={warehouseForm.categoryId}
                  onChange={(e) =>
                    setWarehouseForm({
                      ...warehouseForm,
                      categoryId: e.target.value,
                    })
                  }
                >
                  <option value="">انتخاب کنید</option>
                  {categoryWareHouse.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div> */}

              <div className="col-md-4 mb-3">
                <label htmlFor="categoryWarHouse" className="form-label">
                  شعبه
                </label>
                <select
                  id="categoryWarHouse"
                  className="form-select input-select"
                  aria-label="Default select example"
                  value={warehouseForm.branchId}
                  onChange={(e) => {
                    setWarehouseForm({
                      ...warehouseForm,
                      branchId: e.target.value,
                    });
                  }}
                >
                  <option value="">انتخاب کنید</option>
                  {branchList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-4 mb-4">
                <label htmlFor="title" className="form-label">
                  عنوان
                </label>
                <input
                  className="form-control input-form"
                  type="text"
                  aria-label="Add your item here..."
                  style={{ direction: "rtl", textAlign: "right" }}
                  value={warehouseForm.title}
                  onChange={(e) =>
                    setWarehouseForm({
                      ...warehouseForm,
                      title: e.target.value,
                    })
                  }
                  placeholder="عنوان را وارد بنویسید"
                />
              </div>
              <div className="col-12">
                <label htmlFor="title" className="form-label">
                  توضیحات
                </label>
                <textarea
                  className="form-control input-textarea"
                  type="text"
                  rows={4}
                  aria-label="Add your item here..."
                  style={{ direction: "rtl", textAlign: "right" }}
                  value={warehouseForm.description}
                  onChange={(e) =>
                    setWarehouseForm({
                      ...warehouseForm,
                      description: e.target.value,
                    })
                  }
                  placeholder="توضیحات را وارد بنویسید"
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeWarehouseModal}
              >
                انصراف
              </button>
              <button
                type="button"
                className="btn custome-btn btn-purple"
                onClick={saveWarehouse}
              >
                ثبت و ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const render = () => {
    return (
      <>
        {loading && <Preloading />}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                انبار
                <a
                  href={`/wareHouse/${restaurantId}`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className="d-flex flex-column flex-sm-column-reverse flex-md-row justify-content-md-between align-items-md-baseline  mt-2">
                <span className="fw-bold fs-5">دسته بندی</span>
                <button
                  type="button"
                  id="creatBranch"
                  onClick={openModalCategory}
                  className="btn btn-outline-purple custome-btn d-flex align-items-center justify-content-center"
                >
                  گروه جدید
                  <span className="ms-1">
                    <i className="bi bi-plus-circle align-middle"></i>
                  </span>
                </button>
              </div>
              <div className="text-dark fs-6 mt-5">
                {treeData.map((node) => (
                  <TreeNode
                    key={node.id}
                    node={node}
                    onLoadChildren={handleLoadChildren}
                    openWareHouseModal={openWareHouseModal}
                    selected={selected}
                    onSelect={setSelected}
                    onAdd={handleAddCategory}
                    onEdit={handleEditCategory}
                    onDelete={(n) => {
                      setSelectedDeleteNode(n);
                      setShowDeleteModal(true);
                    }}
                  />
                ))}
              </div>
              <DeleteModal
                showModal={showDeleteModal}
                closeModal={closeDeleteModal}
                deleteItem={deleteNode}
                text={
                  selectedDeleteNode?.nodeType === "warehouse"
                    ? "انبار"
                    : "دسته بندی"
                }
              />
            </div>
          </>
        }
      </>
    );
  };

  return (
    <>
      {render()}
      {showFormModal && categoryModal()}
      {showWareHouseFormModal && addWarehouseModal()}
    </>
  );
};

export default CreateCategoryWarhouse;
